( () => {

    var $ = require( "jquery" );

    const site = {

        bootstrap: () => {

            site.initSlider()
            site.initScrollTo()

        },

        initSlider: () => {

            // Falls es mehrere Slider-Blöcke gibt, nehmen wir alle
            $('.teaser-slider').each( function() {

                $(this).slick( {

                    arrows: true,
                    dots: true,
                    infinite: true,
                    slidesToShow: 1,
                    fade: true,
                    cssEase: 'ease-in-out',
                    speed: 1000,
                    autoplay: true,
                    autoplaySpeed: 8000,
                    prevArrow: $( ".slick__button--left", $(this).parent() ),
                    nextArrow: $( ".slick__button--right", $(this).parent() ),
                    appendDots: $( ".slick__dots", $(this).parent() ),
                    dotsClass: ""

                } )

            } );


            $('.detail-slider').slick( {

                    arrows: false,
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    cssEase: 'ease-in-out',
                    speed: 1000,
                    autoplay: true,
                    autoplaySpeed: 8000,
                    asNavFor: '.detail-slider-nav',
                    dotsClass: ""

            } );

            $('.detail-slider-nav').slick( {

                    arrows: false,
                    dots: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    focusOnSelect: true,
                    asNavFor: '.detail-slider',
                    dotsClass: ""

            } );

        },

        initExpressBanner: () => {

            function mouseOverOpen() {
                if(document.getElementById('express-open').classList.contains("open") === false) {
                    document.getElementById('express-open').style.right = '0px';
                    document.getElementById('express-closed').style.right = '-100%';
                    document.getElementById('express-open').classList.add("open");
                }
            }
            function expressExit() {
                if(document.getElementById('express-open').classList.contains("open")) {
                    document.getElementById('express-open').style.right = '-100%';
                    document.getElementById('express-closed').style.right = '0px';
                    document.getElementById('express-open').classList.remove("open");
                }                
            }

            document.getElementById("express-closed").addEventListener("mouseover", mouseOverOpen);
            document.getElementById("express-closed").addEventListener("click", mouseOverOpen);
            document.getElementById("express-close").addEventListener("click", expressExit);

            // var allOffers = document.getElementsByClassName("offerarea");

            // if(allOffers.length > 0) {
            //     for(let i = 0; i < allOffers.length; i++) {
            //         if(allOffers[i]) {
            //             allOffers[i].addEventListener("mouseover", mouseOverOpen);           
            //             // allOffers[i].addEventListener("mouseout", expressExit);                          
            //         }
            //     }
            // }

        },

        initScrollTo: () => {

            // Scroll-to-top nur anzeigen, wenn der Inhalt größer als der Bildschirm ist
            $(".js-scroll-to-top").toggle( $("body").height() > $(window).height() );

            // Click-Handler
            $(".js-scroll-to-top").on( 'click', () => $("html, body").animate({ scrollTop: 0 }, "slow") )

        }

    };

    $( site.bootstrap )

})()